/* eslint-disable react/prefer-es6-class, react/sort-comp, react/jsx-no-bind */
import classnames from 'classnames';
import React from 'react';
import { t } from 'es6/services/localization';
import UserSettings from 'es6/models/user-settings';

/**
 * Use in conjunction with React BaseModal for the apps.
 *
 * To define which panels are to be used, pass them in
 * below.
 *
 * Example:
 * <SettingsModal panels={[AudioPanel, QuizSettingsPanel, HelpPanel]} panel={AudioPanel} ... />
 */
export const SettingsModal = React.createClass({
  displayName: 'SettingsModal',

  propTypes: {
    inSession: React.PropTypes.bool,

    // Constructor methods for panels.
    panels: React.PropTypes.array.isRequired,

    // Default panel to render (can be undefined/null).
    panel: React.PropTypes.func,
    onSave: React.PropTypes.func.isRequired,
    userSettings: React.PropTypes.object.isRequired,
  },

  /**
   * Keep a copy of userSettings in the state. The modal should
   * not change anything in the original copy.
   */
  getInitialState() {
    return {
      panel: this.props.panel,
      userSettings: new UserSettings(this.props.userSettings),
    };
  },

  getDefaultProps() {
    return {
      inSession: false,
      panel: null,
    };
  },

  componentWillReceiveProps(nextProps) {
    const state = {};

    // Only overwrite the userSettings if receiving new user
    // settings. Reset any changed data.
    if (nextProps.userSettings) {
      state.userSettings = new UserSettings(nextProps.userSettings);
    }

    // Likewise, only change the state if a panel is sent in
    // as a property.
    if (nextProps.panel) {
      state.panel = nextProps.panel;
    }

    this.setState(state);
  },

  /**
   * Chooses the appropriate panel based on what data has been
   * passed in through the parent or based on the user actions performed.
   */
  _getSelectedPanel() {
    return this.props.panels.indexOf(this.state.panel) === -1 ?
      this.props.panels[0] :
      this.state.panel;
  },

  _handleTabClick(panel) {
    this.setState({ panel });
  },

  /**
   * This method is passed down to the other panels, it takes
   * a key from the user setting and a corresponding value to
   * replace that key with.
   *
   * @param {Object} attrs    Changed attributes
   */
  _handleDataChange(attrs = {}) {
    const userSettings = new UserSettings(this.state.userSettings);
    userSettings.update(attrs);

    // Update state with changes to the key
    this.setState({ userSettings });
  },

  render() {
    return (
      <div className="settings-modal content-container">
        <header className="content-details">
          <div className="details-primary">
            {this._renderTabs()}
          </div>
        </header>

        <div className="content-primary">
          {this._renderPanels()}
        </div>

        <footer className="content-actions">
          <a className="btn btn-bar save ok" onClick={this.props.onSave.bind(null, this.state.userSettings)}>{t('js_iknow.save')}</a>
        </footer>
      </div>
    );
  },

  _renderPanels() {
    // If there is no selected panel, just choose the first one.
    const selectedPanel = this._getSelectedPanel();

    return this.props.panels.map((Panel, i) => {
      let className = classnames('settings', { selected: selectedPanel === Panel });

      return (
        <div key={i} className={className}>
          <Panel inSession={this.props.inSession} onDataChange={this._handleDataChange} userSettings={this.state.userSettings} />
        </div>
      );
    });
  },

  _renderTabs() {
    const selectedPanel = this._getSelectedPanel();

    return (
      <ul className="content-tabs">
        {this.props.panels.map((Panel, i) => {
          let className = classnames('content-tab', { selected: selectedPanel === Panel });

          return (
            <li key={i} className={className} onClick={this._handleTabClick.bind(null, Panel)}>{Panel.getTabName()}</li>
          );
        })}
      </ul>
    );
  },
});

export default SettingsModal;
